import React, { Fragment, useRef } from 'react';
import { useIntl } from 'react-intl';

import { ICONS } from '../../../../consts/consts';
import ScrollableUncontrolledPopover from '../../ScrollableUncontrolledPopover';
import {
  getONACellListHeader,
  getONACellListHelperText,
  groupONAByType,
  TeamDashboardPerson,
} from './common';
import ONAList from './ONAList';

type Props = {
  person: TeamDashboardPerson;
  uniqueId: string;
};

const GoldStarCell: React.FC<Props> = ({ person, uniqueId }) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const targetRef = useRef<HTMLSpanElement>(null);

  const groupedONA = groupONAByType(person.goldstars?.[1] ?? [], formatMessage);

  return (
    <>
      <span ref={targetRef} id={'row-gold-stars-' + uniqueId}>
        <i className={ICONS.GOLD_STAR} />
        &nbsp;
        {person.goldstars_count}
      </span>
      {person.goldstars_count > 0 && (
        <ScrollableUncontrolledPopover
          placement="left"
          trigger="hover"
          target={targetRef}
        >
          {groupedONA.map(([onaSourceType, goldstars], index) => {
            return (
              <Fragment key={`gold-star-ona-list-item-${onaSourceType}`}>
                {index > 0 && <hr></hr>}
                <ONAList
                  iconClassName={ICONS.GOLD_STAR}
                  header={getONACellListHeader(onaSourceType, intl)}
                  onaList={goldstars}
                  helperText={getONACellListHelperText(onaSourceType)}
                />
              </Fragment>
            );
          })}
        </ScrollableUncontrolledPopover>
      )}
    </>
  );
};

export default GoldStarCell;
